import { render, staticRenderFns } from "./listaCupones.vue?vue&type=template&id=315adc92&scoped=true&"
import script from "./listaCupones.vue?vue&type=script&lang=js&"
export * from "./listaCupones.vue?vue&type=script&lang=js&"
import style0 from "./listaCupones.vue?vue&type=style&index=0&id=315adc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315adc92",
  null
  
)

export default component.exports